import firebase from "firebase/app";
import "firebase/firestore";

export const firebaseConfig = {
    apiKey: "AIzaSyD_FidjHLNJa3n2jvTqFt2V9_Kdvkc5qKg",
    authDomain: "mkss-9b4e0.firebaseapp.com",
    projectId: "mkss-9b4e0",
    storageBucket: "mkss-9b4e0.appspot.com",
    messagingSenderId: "1027897425378",
    appId: "1:1027897425378:web:a466709e4b58dcfceb8dbb",
    measurementId: "G-G3FDLB1VMH"
};


export const firebaseInitialize = (config) => {
    if (!firebase.apps.length) {
        firebase.initializeApp(config);
    };
};

export const getFirebaseApp = (name, config) => {
    let foundApp = firebase.apps.find(app => app.name === name);
    return foundApp ? foundApp : firebase.initializeApp(config || firebase.app().options, 'auth-worker');
}

export const firestoreInitialize = () => {
    return firebase.firestore();
};